import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { QualityManagementResponse } from '@/types/apps/quality-management.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface QualityManagementGraphQLServiceInterface {}

type QualityManagementGraphQLListResponse =
    GqlListResponse<QualityManagementResponse>;

export class QualityManagementGraphQLService
    extends BaseService
    implements QualityManagementGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'qualityManagement';
    }

    public getFields(): Record<string, any> {
        return {
            checklist: true,
            code: true,
            completionQualityManagement: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            evaluationGroup: true,
            id: true,
            improvementProposal: true,
            inspectionDate: true,
            inspectionResult: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            note: true,
            periodType: true,
            reportType: true,
            userId: true,
            appUser: {
                fullname: true,
                id: true,
            },
        };
    }

    public async index(
        query: string
    ): Promise<QualityManagementGraphQLListResponse> {
        return this.fetchGqlList<QualityManagementGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('qualityManagement', {
            userId: this.getQueryById(),
        });
    }
}
